import {
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_FAILURE_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_FAILURE_DK,
    FETCH_STOCKLEDGER_OPENINGSTOCK_REQUEST_DK,
    FETCH_STOCKLEDGER_OPENINGSTOCK_SUCCESS_DK,
    FETCH_STOCKLEDGER_OPENINGSTOCK_FAILURE_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_FAILURE_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_FAILURE_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_FAILURE_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_DATE_REQUEST_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_DATE_SUCCESS_DK,
    FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_DATE_FAILURE_DK
} from './stockWiseReportsLedgerDetails.actionsType';

export const STOCKWISEREPORTSLEDGER_DK_DETAILS = 'stockLedgerDetailsDK';

let initialState = {
    loading: false,
    stockLedgerDKDetailsById: [],
    stockLedgerDKDetails: [],
    stockLedgerFabricDetailsById: [],
    stockLedgerFabricDetails: [],
    stockLedgerDKOpeningStock: [],
    stockLedgerDetailsSelectedValue: {},
    //isStockReportLedgerDetail: false
    errorMessage: '',
    iperrorMessage: ''
};

export let stockLedgerDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_REQUEST_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_REQUEST_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_REQUEST_DK:
        case FETCH_STOCKLEDGER_OPENINGSTOCK_REQUEST_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_REQUEST_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_REQUEST_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_DATE_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_SUCCESS_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stockLedgerDKDetails: updatePayload
            };
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stockLedgerFabricDetails: updatePayload
            };
        case FETCH_STOCKLEDGER_OPENINGSTOCK_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stockLedgerDKOpeningStock: updatePayload
            };
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stockLedgerDKDetailsById: updatePayload
            };
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                stockLedgerFabricDetailsById: updatePayload
            };
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_FAILURE_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_STOCKLEDGER_OPENINGSTOCK_FAILURE_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_DETAILS_DATE_FAILURE_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_FAILURE_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_BY_ID_FAILURE_DK:
        case FETCH_STOCKWISEREPORTSLEDGER_FABRIC_DETAILS_DATE_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        default:
            return state;
    }
};
